import {Container} from "../Core/Container";
import {array} from "../Core/Reflection";
import {Sprite} from "../Core/Sprite";
import {Ease} from "../Core/Animatable";
import {AudioChannel} from "../Core/AudioChannel";

export class KnockKnock extends Container {

    public readonly knock = array(() => this.addChild(new Sprite()));

    constructor() {
        super();
        this.visible = false;
    }

    show() {
        this.visible = true;
        let d = 0;
        for (const knock of this.knock) {
            knock.killTweens();
            knock.scale.set(0);
            knock.scaleTo(2, 0.4, Ease.backOut, {delay: d});
            d += 0.2;
        }
        AudioChannel.SFX.play("knockknock");
    }

    hide() {
        this.visible = false;
    }
}